import React from 'react';
import { ServerService } from './../../../services/server.service';
import { ImageService } from './../../../services/image.service';
import ReactToolTip from 'react-tooltip';
import $ from 'jquery';
import BackupService from '../../../services/backup.service';
import { getLocalTime, getLocalDay } from '../../../utility/utility';
import { AuditLog } from './../../../services/auditlog.service';
import { SessionService } from './../../../services/session.service';
import i18n from "./../../../i18n.js";

class Backup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            schedulename: '',
            rotations: 1,
            errorMessage: '',
            backupList: [],
            backupImageList: [],
            selectedBackupId: '',
            nameToggle: true,
            typeToggle: false,
            datetoggle: false,
            selectedBackup: '',
            isAction: false,
            isNotLoaded: true,
            isWeeklyBackup: true,
            isDailyBackup: true,
            isdisabled: false,
            isSuspended: localStorage.getItem("status") === "S",
        };

    }
    componentDidMount() {
        $("main").removeClass("ls_expand");
        $("html").animate({ scrollTop: 0 }, "slow");
        this.getBackupList();
        if(SessionService.getCookie("_message_backup") == "show") {
            this.props.msgHandler("The daily backup has been scheduled sucessfully", 'success');
            this.clearToastMessage();
            SessionService.removeCookie("_message_backup");
        }
    }

    clearToastMessage = () => {
        setTimeout(() => {
            this.props.msgHandler("");
        }, 10000);
    };


    getBackupList() {
        this.props.bgShadowHandler(true);
        BackupService.getScheduleList(this.props.instance.id).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp && resp.length >= 0) {
                this.setEnableDisbleBttn(resp);
                this.setState({ backupList: resp, isNotLoaded: false, isAction: false });
            } else if(resp && resp.message) {
                this.props.msgHandler(resp.message, 'warning');
                this.clearToastMessage();
                this.setState({ isNotLoaded: true });
            }
        });
    }
    getBackupImageList() {
        let geturl = window.location.href;
        if(geturl.indexOf("backup") === -1) {
            return;
        }
        ImageService.getAllImageDetailsByType(this.props.imageRegionUrl, this.props.instanceId, 'backup').then(resp => {
            if(resp.images && resp.images.length > 0) {
                let isdis = false;
                let ob = resp.images.find(item => item.status !== 'active');
                if(ob !== undefined) {
                    isdis = true;
                    sessionStorage.backupTimer = setTimeout(() => this.getBackupImageList(), 1000);
                }
                this.setState({ backupImageList: resp.images, isdisabled: isdis });
            }
        });
    }
    componentWillUnmount() {
        clearTimeout(sessionStorage.backupTimer);
        this.props.msgHandler("");
    }
    setEnableDisbleBttn(items) {
        let dailyBackup = this.state.isDailyBackup;
        let weeklyBackup = this.state.isWeeklyBackup;
        if(items.length > 0) {
            items.forEach(element => {
                if(element.type === 'daily') {
                    if(element.is_cancelled === 0) {
                        dailyBackup = false;
                    } else {
                        dailyBackup = true;
                    }
                }
                if(element.type === 'weekly') {
                    if(element.is_cancelled === 0) {
                        weeklyBackup = false;
                    } else {
                        weeklyBackup = true;
                    }
                }
            });
        }
        this.setState({ isDailyBackup: dailyBackup, isWeeklyBackup: weeklyBackup });
    }

    handleinputs = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        this.setState({ [name]: val });
        if(name === 'schedulename' && val !== '') {
            this.setState({ errorMessage: '' });
        }
    };
    isDuplicte(name) {
        let backupList = this.state.backupList;
        if(backupList.length > 0) {
            let ob = backupList.find(item => item.name === name);
            if(ob !== undefined) {
                return true;
            }
        }
        return false;
    }
    submit = (event) => {
        if(this.state.isAction) {
            return;
        }
        if(this.state.scheduletype === undefined || this.state.scheduletype === '') {
            return;
        }
        if(this.state.schedulename === undefined || this.state.schedulename.trim() === '') {
            this.setState({ errorMessage: 'Schedule name cannot be blank', schedulename: '' });
            document.getElementById("schedulename").focus();
            return;
        }
        let trimScheduleName = this.state.schedulename.trim();
        if(this.isDuplicte(this.state.trimScheduleName)) {
            this.setState({ errorMessage: 'Schedule name cannot be duplicate' });
            document.getElementById("schedulename").focus();
            return;
        }
        this.setState({ errorMessage: '', isAction: true });
        this.createBackupSchedule(trimScheduleName, this.state.scheduletype, this.state.rotations, 'Backup schedule is being created');
    };

    backupKeyDown = (e) => {
        if(e.keyCode == 13) {
            this.submit(e);
        }
    };

    onBackupScheduleClick(scheduletype) {
        let i18n = this.props.i18n;
        if(this.state.isAction || localStorage.getItem("status") === 'S') {
            return;
        }
        if(scheduletype === 'weekly') {
            this.createBackupSchedule(scheduletype, 1, i18n.t('inst_bckp_weeklyCrea_success'));
            return;
        }
        this.createBackupSchedule(scheduletype, 1, i18n.t('inst_bckp_dailyCrea_success'));

    }

    createBackupSchedule(scheduletype, rotations, successMessag) {
        let name = this.props.instance.name + '-backup-' + scheduletype;
        let requestBody = { createBackup: {} };
        requestBody.createBackup.name = name;
        requestBody.createBackup.backup_type = scheduletype;
        requestBody.createBackup.rotation = rotations;
        this.props.bgShadowHandler(true);
        this.createEditSchedule(scheduletype, successMessag, name);
        // ServerService.serverAction(this.props.instanceId, this.props.computeRegionUrl, requestBody).then(resp => {
        //     if (resp) {
        //         this.props.bgShadowHandler(false)
        //         this.props.msgHandler('Cannot create backup state while it is in task state of image uploading, Please try after 2 minutes', 'warning');
        //         return;
        //     }
        //     this.createEditSchedule(scheduletype,successMessag,name)
        // });
    }

    createEditSchedule(scheduletype, successMessag, name) {
        let ob = this.state.backupList.find(item => item.type === scheduletype);
        if(ob === undefined) {
            this.createSchedule(successMessag, name, scheduletype);
        } else {
            this.editSchedule(ob, successMessag, scheduletype);
        }

    }

    createSchedule(successMessag, name, scheduletype) {
        let requestBody = {
            instance_id: this.props.instanceId,
            name: name,
            region: this.props.instance.region,
            type: scheduletype
        };
        BackupService.createSchedule(requestBody).then(resp => {
            console.log(resp);
            if(resp == "INSTANCE_ALREADY_EXISTS") {
                this.getBackupList();
                this.props.bgShadowHandler(false);
                this.props.msgHandler("The " + scheduletype + " backup already exists", 'error');
                this.clearToastMessage();
                return;
            }



            if(resp && resp.id) {
                const enableBack = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.props.instance.name + " has been enabled for " + scheduletype + " backup",
                    "region": this.props.instance.region,
                    "operation": "Backup Enabled"
                };
                AuditLog.storeAuditLogs(enableBack, "instance").then((resp) => {
                    if(resp === false);
                });

                this.getBackupList();

                //this.getBackupImageList();
                //let time = this.getAfterTime(scheduletype)
                //successMessag = successMessag + time
                this.props.bgShadowHandler(false);
                this.props.msgHandler(successMessag, 'success');
                this.clearToastMessage();

                return;
            }
            this.setState({ isAction: false });
            this.props.bgShadowHandler(false);
            this.props.msgHandler(i18n.t("inst_bckp_Crea_failure"), 'error');
            this.clearToastMessage();
        });
    }

    editSchedule(ob, successMessag, scheduletype) {
        BackupService.editSchedule(ob.id).then(resp => {
            if(resp && resp.id) {
                this.getBackupList();
                const requestBdy = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.props.instance.name + " has been enabled for " + scheduletype + " backup",
                    "operation": "Backup Enabled"
                };
                AuditLog.storeAuditLogs(requestBdy, "instance").then((resp) => {
                    if(resp === false);
                });
                //this.getBackupImageList();
                //let time = this.getAfterTime(scheduletype)
                //successMessag = successMessag + time
                this.props.bgShadowHandler(false);
                this.props.msgHandler(successMessag, 'success');
                this.clearToastMessage();
                //this.setState({isdisabled:true})
                return;
            }
            this.setState({ isAction: false });
            this.props.bgShadowHandler(false);
            this.props.msgHandler(i18n.t("inst_bckp_Crea_failure"), 'error');
            this.clearToastMessage();
        });
    }

    onDeleteClick = (type) => {
        if(this.state.isAction) {
            return;
        }
        this.props.bgShadowHandler(true);
        let i18n = this.props.i18n;
        let selectedBackupId = this.state.backupList.find(item => item.type === type).id;
        BackupService.cancelScheduleByid(selectedBackupId).then(resp => {
            this.props.bgShadowHandler(false);
            if(resp && resp.id) {
                this.getBackupList();
                const requestBdy = {
                    "userId": localStorage.getItem("userId"),
                    "name": "Instance " + this.props.instance.name + " has been disabled for " + type + " backup",
                    "operation": "Backup Disabled",
                    "region": this.props.instance.region
                };
                AuditLog.storeAuditLogs(requestBdy, "instance").then((resp) => {
                    if(resp === false);
                });
                if(type === 'weekly') {
                    this.props.msgHandler(i18n.t('inst_bckp_weeklyDis_success'), 'success');
                    this.clearToastMessage();
                } else {
                    this.props.msgHandler(i18n.t('inst_bckp_dailyDis_success'), 'success');
                    this.clearToastMessage();
                }
                return;
            }
            this.props.msgHandler(i18n.t('inst_bckp_dis_failure'), 'error');
            this.clearToastMessage();
        });
    };

    setSortable(type) {
        this.setState({ nameToggle: !this.state.nameToggle }, this.setState({ backupList: this.getSortable(type, this.state.backupList) }));

    }

    getSortable = (type, items) => {
        if(items && items.length === 0) {
            return items;
        }
        this.setState({ columnName: type });
        if(type === "name") {
            if(this.state.nameToggle) {
                items.sort(function (a, b) {
                    if(a.name < b.name) { return -1; }
                    if(a.name > b.name) { return 1; }
                    return 0;
                });
            } else {
                items.sort(function (a, b) {
                    if(a.name < b.name) { return 1; }
                    if(a.name > b.name) { return -1; }
                    return 0;
                });
            }
            this.setState({ nameToggle: !this.state.nameToggle });
            return items;
        } else if(type === "type") {
            if(this.state.typeToggle) {
                items.sort(function (a, b) {
                    if(a.type < b.type) { return -1; }
                    if(a.type > b.type) { return 1; }
                    return 0;
                });
            } else {
                items.sort(function (a, b) {
                    if(a.type < b.type) { return 1; }
                    if(a.type > b.type) { return -1; }
                    return 0;
                });
            }
            this.setState({ typeToggle: !this.state.typeToggle });
            return items;
        } else if(type === "date") {
            if(this.state.datetoggle) {
                items.sort(function (a, b) {
                    return new Date(a.next_backup) - new Date(b.next_backup);
                });
            }
            else {
                items.sort(function (a, b) {
                    return new Date(b.next_backup) - new Date(a.next_backup);
                });
            }
            this.setState({ datetoggle: !this.state.datetoggle });
            return items;
        }
    };

    headerSortClick = (event) => {
        $('.sort_icon').removeClass('active');
        $(event.currentTarget).find('.sort_icon').addClass('active');
        $(event.currentTarget).find('.sort_icon').toggleClass('toggle_sort');
    };
    getTime(type) {
        let date = 'tomorrow';
        let backupList = this.state.backupList;
        if(backupList.length > 0) {
            let ob = backupList.find(item => item.type === type && item.is_cancelled !== 1);
            if(ob !== undefined) {
                return getLocalDay(ob.next_backup);
            }
        }
        if(type === 'weekly') {
            return 'next week';
        }
        return date;
    }
    getAfterTime(type) {
        let endDate = new Date();
        let timePeriod = 1;
        if(type === 'weekly') {
            timePeriod = 7;
        }
        endDate = new Date(endDate.setDate(endDate.getDate() + timePeriod));
        return getLocalDay(endDate);
    }

    render() {

        return (
            <section className="settingModule_wrapper backup_setting_module">
                {/* <div className="boot_container" style={{ display: this.state.isdisabled && (this.state.isDailyBackup || this.state.isWeeklyBackup)?'':'none',paddingTop:'10px' }}>
                    <div className="boot_wrapper">
                        <div className="progress_wrap">
                            <div className="title_head"><span className="head_title">Image upload is in progress. Enable backups will be enabled only after the image upload is finished</span></div>
                            <div className="progress_bar"><span className="percent_progress" style={{ width: '100%' }}></span></div>
                        </div>
                    </div>
                </div> */}
                <div className="settModule_head_wrap">
                    <div className="settModule_head_lhs">
                        <h2>Backups</h2>
                        <p className="para_info">Enabling backup will schedule an automatic rotation as per the selected option</p>
                        <p className="head_info" style={ { display: !this.state.isDailyBackup ? '' : 'none' } }>Daily backup is currently enabled and next backup will start on <b>{ this.getTime('daily') }</b></p>
                        <p className="head_info" style={ { display: !this.state.isWeeklyBackup ? '' : 'none' } }>Weekly backup is currently enabled and next backup will start on <b>{ this.getTime('weekly') }</b></p>
                    </div>
                </div>

                <div className="backupModule_wrap" style={ { display: this.state.isNotLoaded === true ? 'none' : '' } }>
                    <div className="btn_container">
                        <input type="button" name="" style={ { display: this.state.isDailyBackup ? '' : 'none' } } value="Enable daily backup" className={ (this.state.isdisabled || this.state.isSuspended) ? "common_cta_btn blue disabled" : "common_cta_btn blue" } onClick={ () => this.onBackupScheduleClick('daily') } disabled={ this.state.isdisabled } />
                        <input type="button" name="" style={ { display: !this.state.isDailyBackup ? '' : 'none' } } value="Disable daily backup" className="common_cta_btn disableBtn" onClick={ () => this.onDeleteClick('daily') } />
                        <input type="button" name="" style={ { display: this.state.isWeeklyBackup ? '' : 'none' } } value="Enable weekly backup" className={ (this.state.isdisabled || this.state.isSuspended) ? "common_cta_btn blue disabled" : "common_cta_btn blue" } onClick={ () => this.onBackupScheduleClick('weekly') } disabled={ this.state.isdisabled } />
                        <input type="button" name="" style={ { display: !this.state.isWeeklyBackup ? '' : 'none' } } value="Disable weekly backup" className="common_cta_btn disableBtn" onClick={ () => this.onDeleteClick('weekly') } />
                    </div>
                    <p className="para_info">Backups are charged <b>$0.05/GB/month</b> additionally</p>

                </div>

                <div className="main_popup delete_backup_popup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" ></span>
                                <div className="popup_header">
                                    <div className="sub_title" >Cancel</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to cancel the image backup schedule <b>{ this.state.selectedBackup.name }</b> ?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn btn_confirm" onClick={ () => this.onDeleteClick('wee') }>Cancel</div>
                                        <div className="btn btn_cancel" >No</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        );
    }
}

export default Backup;
